import React, { useCallback, useEffect, useState } from 'react';
import AdminLayoutWrapper from '../AdminLayoutWrapper';
import { Button, Table, Card, message, Breadcrumb } from 'antd';
import { getServiceEntryByDomain } from '../../../apis/serviceEntry';
import { assignService } from '../../../apis/teams';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';
import ProtectAdminRoute from './custom/adminRoute';

const styles = {
  "notiText": {
    fontSize: 14,
    fontWeight: 500
  },
  "titlePage": {
    fontSize: 20,
    fontWeight: 700
  },
  "tableToolbar": {
    marginBottom: 16,
  }
}


const columns = [
  {
    title: 'Service Name',
    dataIndex: 'name',
  },
  {
    title: 'Domain Group',
    dataIndex: 'domain_group',
  },
  {
    title: 'Description',
    dataIndex: 'description',
  },
]

const AssignTeamService = () => {
  const [listServices, setListServices] = useState([]);
  const [selectedRowKeys, setSelectedRow] = useState([]);
  const { id } = useParams();

  const fetchAllServices = useCallback(async () => {
    const { data } = await getServiceEntryByDomain();
    let listAllServices = [];
    data.forEach(service => {
      if (service && service.service_entries) {
        listAllServices = [
          ...listAllServices,
          ...service.service_entries
        ];
      }
    });
    const newListServices = listAllServices
      .filter((service) => {
        return service.team_id.toString() !== id
      })
      .map((service) => {
        return {
          ...service,
          key: service.id
        }
      })
    setListServices(newListServices);
  }, [id])

  useEffect(() => {
    fetchAllServices();
  }, [fetchAllServices]);

  const handleSelectedRow = (value, row) => {
    setSelectedRow(value)
  }

  const rowSelection = {
    selectedRowKeys: selectedRowKeys,
    onChange: handleSelectedRow
  }

  const handleSaveAssignment = async () => {
    try {
      const result = await assignService(id, {
        service_entry_ids: selectedRowKeys
      });
      setSelectedRow([]);
      fetchAllServices();
      message.success("Assigned Service Successfully");
    } catch (error) {
      console.log(error);
      message.error('The system can not handle request. Please try again later')
    }
  }

  return (
    <AdminLayoutWrapper>
      <ProtectAdminRoute>
        <div style={{ padding: '0px 0px 16px 0px' }}>
          <Breadcrumb>
            <Breadcrumb.Item>Home</Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/teams/me`}>Manage Team</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/teams/${id}/services`}>Team Services</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              Assign Team Services
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
        <Card>
          <h1 style={styles.titlePage}>List Available Services</h1>
          {selectedRowKeys && selectedRowKeys.length === 0 && <p><i>Please select services in table below</i></p>}
          {selectedRowKeys && selectedRowKeys.length > 0 && (
            <div style={styles.tableToolbar}>
              <Button onClick={handleSaveAssignment} style={{ marginRight: 8 }} type="primary">Save</Button> <span style={styles.notiText}>Selected {selectedRowKeys.length} / {listServices.length}</span>
            </div>)}
        </Card>
        <Card>
          <Table
            dataSource={listServices}
            columns={columns}
            rowSelection={rowSelection}
          />
        </Card>
      </ProtectAdminRoute>
    </AdminLayoutWrapper>
  )
}

export default AssignTeamService;
